import React from "react";
import { Link } from "react-router";
import { FormattedMessage } from "react-intl";

const UnauthorizedPage = () => {
  const redirect = () => (window.location.href = '/');

  return (
    <div className="page-container">
      <div className="page-content">
        <h4>
          <FormattedMessage id="error.403.title" />
        </h4>
        <Link to="/" onClick={redirect}>
          <FormattedMessage id="error.403.link" />
        </Link>
      </div>
    </div>
  );
};

export default UnauthorizedPage;



// WEBPACK FOOTER //
// ./src/components/app/UnauthorizedPage.js